import React from 'react';
//import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';

import spe from '../spe';
import IsSpeDue from './SpeDue';

const styles = {
    iconRed: { 
           paddingRight: '0.5em' ,
           color: 'orange'
        },
    icon: { 
        paddingRight: '0.5em' ,
        },
    link: {
        display: 'inline-flex',
        alignItems: 'center'
    },
};

const LinkToSpe = ({ classes, record, brcode }) => (
    //console.log(record.deferral_code),

    <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/spe',
            search: stringify({
                page: 1,
                perPage: 25,
                sort: 'id',
                order: 'DESC',
                filter: JSON.stringify({ 
                    ssn: record.ssn, 
                    deferral_code: record.deferral_code, 
                    deferral_date: record.deferral_date,
                    deferral_exp_date: record.deferral_exp_date ,
                    deferral_comments: record.deferral_comments,
                    branch_code: brcode,
                }),
            }),
        }}
        className={classes.link}
    >
  
        <spe.icon className={(IsSpeDue(record) && IsSpeDue(record).id ===1)?  classes.iconRed: classes.icon} />SPE
    </Button>
    
);
/*
const enhance = compose(
    withStyles(styles),
    
);*/
export default withStyles(styles)(LinkToSpe);